import * as React from 'react'
import PropTypes from 'prop-types'
import {
  HeroSection,
  HeaderContainer,
  CTAContainer,
  MobileMediaContainer,
  MediaContainer,
} from './styles'
import CTAButton from '../CTAButton/CTAButton'
import { HeroHeader } from './HeroHeader'
import { HeroMedia } from './HeroMedia'

export default function LPHero({
  useLogo = false,
  logoUrl,
  logoAlt,
  headingCopy,
  subHeadlineCopy,
  addTagCopy = false,
  tagCopy,
  heroImageUrl = 'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F53dd54d8ac3e42219b8e9a1bba44d054',
  heroImgAlt,
  hasDualCta,
  stackButtons = false,
  cta1Text,
  cta1FontSize = 'medium',
  cta1UseFullWidth = false,
  cta1Link,
  cta1Analytics,
  cta1BackgroundColor = 'coral',
  cta1Variant,
  cta2Text,
  cta2FontSize = 'medium',
  cta2UseFullWidth = false,
  cta2Link,
  cta2Analytics,
  cta2BackgroundColor = 'coral',
  cta2Variant,
  isVideo,
  mp4VideoUrl,
}) {
  return (
    <HeroSection>
      <MobileMediaContainer>
        <HeroMedia
          imageUrl={heroImageUrl}
          imageAlt={heroImgAlt}
          isVideo={isVideo}
          videoUrl={mp4VideoUrl}
        />
      </MobileMediaContainer>
      <HeaderContainer>
        <HeroHeader
          headingCopy={headingCopy}
          subHeadlineCopy={subHeadlineCopy}
          addTagCopy={addTagCopy}
          tagCopy={tagCopy}
          useLogo={useLogo}
          logoUrl={logoUrl}
          logoAlt={logoAlt}
        />
        <CTAContainer stackButtons={stackButtons}>
          <CTAButton
            ctaLink={cta1Link}
            ctaVariant={cta1Variant}
            ctaAnalytics={cta1Analytics}
            backgroundColor={cta1BackgroundColor}
            fontSize={cta1FontSize}
            useFullWidth={cta1UseFullWidth}
          >
            {cta1Text}
          </CTAButton>
          {hasDualCta && (
            <CTAButton
              ctaLink={cta2Link}
              ctaVariant={cta2Variant}
              ctaAnalytics={cta2Analytics}
              backgroundColor={cta2BackgroundColor}
              fontSize={cta2FontSize}
              useFullWidth={cta2UseFullWidth}
            >
              {cta2Text}
            </CTAButton>
          )}
        </CTAContainer>
      </HeaderContainer>
      <MediaContainer>
        <HeroMedia
          imageUrl={heroImageUrl}
          imageAlt={heroImgAlt}
          isVideo={isVideo}
          videoUrl={mp4VideoUrl}
        />
      </MediaContainer>
    </HeroSection>
  )
}

LPHero.propTypes = {
  useLogo: PropTypes.bool,
  logoUrl: PropTypes.string,
  logoAlt: PropTypes.string,
  headingCopy: PropTypes.string,
  subHeadlineCopy: PropTypes.string,
  addTagCopy: PropTypes.bool,
  tagCopy: PropTypes.string,
  heroImageUrl: PropTypes.string,
  heroImgAlt: PropTypes.string,
  hasDualCta: PropTypes.bool.isRequired,
  stackButtons: PropTypes.bool,
  cta1Text: PropTypes.string.isRequired,
  cta1FontSize: PropTypes.string,
  cta1UseFullWidth: PropTypes.bool,
  cta1Link: PropTypes.string.isRequired,
  cta1Analytics: PropTypes.string,
  cta1BackgroundColor: PropTypes.string,
  cta1Variant: PropTypes.bool.isRequired,
  cta2Text: PropTypes.string,
  cta2FontSize: PropTypes.string,
  cta2UseFullWidth: PropTypes.bool,
  cta2Link: PropTypes.string,
  cta2Analytics: PropTypes.string,
  cta2BackgroundColor: PropTypes.string,
  cta2Variant: PropTypes.bool,
  isVideo: PropTypes.bool.isRequired,
  mp4VideoUrl: PropTypes.string,
}
